import React, { useContext, useEffect } from "react";

import DatabaseContext from "data/contextDatabase";

import { useLiveQuery } from "dexie-react-hooks";
import { rest_api } from "connectivity/API";
import { dex_action } from "./dexUtils";
import GlobalContext from "contexts/context";
import { shouldLog } from "utils/shouldLog";

const timer = new Date().getTime();

const ListFetcher = (props) => {
  const { globalState } = useContext(GlobalContext);
  const { databaseState } = useContext(DatabaseContext);

  const liveHideArchived = useLiveQuery(
    () =>
      databaseState.dexUser &&
      databaseState.dexUser.account.get("hideArchived"),
    [databaseState.dexUser]
  );

  const uid = useLiveQuery(
    () =>
      databaseState.dexAdmin &&
      databaseState.dexAdmin.store.get({ key: "user" }).then((u) => u?.uid),
    [databaseState.dexAdmin]
  );

  const jwt = useLiveQuery(
    () =>
      databaseState.dexAdmin &&
      databaseState.dexAdmin.store.get({ key: "user" }).then((u) => u?.jwt),
    [databaseState.dexAdmin]
  );

  const fetchTopicList = () => {
    if (
      jwt &&
      uid &&
      databaseState?.dexAdmin &&
      databaseState.dexUser &&
      globalState.authenticated
    ) {
      let action = {
        type: "r_t_list",
        jwt: jwt,
        version: "",
        concise: "false",
        url: process.env.REACT_APP_URL
      };

      shouldLog() && console.log("[ListFetcher] Attempting to fetch r_t_list");

      // R_T_LIST
      rest_api(action)
        .then((r) => {
          shouldLog() &&
            console.log("[ListFetcher] Successfully fetched r_t_list");

          r.topics &&
            dex_action({
              type: "DEX_UPSERT_MATCH",
              values: {
                db: databaseState.dexAdmin,
                table: "store",
                match: { key: "user" },
                function: (val) => {
                  let v = val;
                  if (val?.uid === uid && val?.muid !== r.muid)
                    v = { ...val, muid: r.muid };
                  return v;
                }
              }
            });
          shouldLog() && console.log("ListFetcher r.topics", r.topics);
          if (r.topics) {
            dex_action({
              type: "DEX_PUT_IF_DIFF",
              values: {
                db: databaseState.dexUser,
                table: "account",
                primaryKey: { type: "topics" },
                doc: {
                  value: liveHideArchived?.value
                    ? r.topics.filter((t) => t.subprops?.archived !== "true")
                    : r.topics,
                  type: "topics",
                  time: Date.now()
                }
              }
            });
          }
        })
        .catch((e) => {
          console.log("[ListFetcher] rest_api error", e);

          // Immediately fall back to WebSocket method without retrying
          console.log("[ListFetcher] Falling back to WebSocket method.");

          // Try to trigger the w.t.list via WebSocket as a fallback
          if (databaseState.dexUser) {
            const sj = {
              type: "w.t.list",
              version: globalState.version,
              url: process.env.REACT_APP_URL,
              concise: "false",
              smid: "w.t.list"
            };

            dex_action({
              type: "DEX_PUT",
              values: {
                db: databaseState.dexUser,
                table: "send",
                doc: sj
              }
            });
            console.log("[ListFetcher] w.t.list request sent via WebSocket");
          }
        });
    }
  };

  useEffect(() => {
    shouldLog() &&
      console.log(
        "ListFetcher 1",
        jwt,
        uid,
        databaseState?.dexAdmin,
        databaseState.dexUser,
        globalState.authenticated
      );

    fetchTopicList();

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    jwt,
    databaseState.dexUser,
    uid,
    globalState.authenticated,
    liveHideArchived?.value
  ]);

  shouldLog() && console.log("ListFetcher timer", new Date().getTime() - timer);
  return null;
};

export default React.memo(ListFetcher, (prevProps, nextProps) => {
  return true;
});
